<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage shippinglines</small>
      </legend>
      <div></div>
      <div>
        <div class="shippinglinesLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa spin" style="font-size: 24px; color: blue"></i>loading shippinglines...
        </div>

        <vue-good-table
          :columns="columns"
          :rows="systemShippinglines"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
        }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'Action'">
              <button
                v-b-tooltip.hover.bottom="'Edit shippingline!'"
                class="btn btn-info btn-sm btn-rounded"
                @click="viewShippingline(props.row.id)"
              >
                <i class="fa fa-edit"></i> Edit Shippingline
              </button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "Shipping line",
          field: "shipping_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter shipping line"
          }
        },
        {
          label: "Free days",
          field: "free_days",
          type: "text"
        },
        {
          label: "OOG days",
          field: "oog",
          type: "text"
        },
        {
          label: "Action",
          field: "Action",
          width: "85px",
          html: true
        }
      ]
    };
  },
  created() {
    this.loadShippinglines();
  },
  computed: {
    ...mapGetters(["systemShippinglines"])
  },
  methods: {
    ...mapActions(["loadShippinglines", "viewShippingline"])
  }
};
</script>



// WEBPACK FOOTER //
// src/shippinglines/manageshippinglines.vue